// Utility functions for member components

export const getMembershipStatusColor = (status) => {
  switch (status) {
    case 'active':
      return 'success';
    case 'expired':
      return 'warning';
    case 'cancelled':
      return 'error';
    case 'pending':
      return 'warning';
    default:
      return 'default';
  }
};

export const getMembershipStatusText = (status) => {
  switch (status) {
    case 'active':
      return 'Attiva';
    case 'expired':
      return 'Scaduta';
    case 'cancelled':
      return 'Cancellata';
    case 'pending':
      return 'Da pagare';
    default:
      return 'Nessuna';
  }
};

export const getRoleDisplayName = (role) => {
  switch (role) {
    case 'admin':
      return 'Amministratore';
    case 'teacher':
      return 'Docente';
    default:
      return 'Membro';
  }
};

export const getRoleColor = (role) => {
  switch (role) {
    case 'admin':
      return 'error';
    case 'teacher':
      return 'warning';
    default:
      return 'primary';
  }
};


export const formatCurrency = (amount, currency = 'EUR') => {
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: currency
  }).format(amount);
}; 